import { render, staticRenderFns } from "./EditShift.vue?vue&type=template&id=b5623c30&scoped=true"
import script from "./EditShift.vue?vue&type=script&lang=js"
export * from "./EditShift.vue?vue&type=script&lang=js"
import style0 from "./EditShift.vue?vue&type=style&index=0&id=b5623c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5623c30",
  null
  
)

export default component.exports